'use client';
const IDENT = 'SimpleGrid';
const defaultProps = {
    cols: 1,
    spacing: '4s'
};

export { IDENT, defaultProps };
//# sourceMappingURL=SimpleGrid.contract.js.map
